import { useQuery } from "@/api/swr/useQuery";
import { assessmentProgressSchema } from "@/schema/AssessmentProgress";
import { z } from "zod";

export function useGetAssessmentProgresses(status?: string) {
  const url = status
    ? `/console/assessment_progresses?status=${status}`
    : "/console/assessment_progresses";
  return useQuery(z.array(assessmentProgressSchema), url);
}
